import { render, staticRenderFns } from "./ApothekeRechnung.vue?vue&type=template&id=2c17c49c&"
import script from "./ApothekeRechnung.vue?vue&type=script&lang=js&"
export * from "./ApothekeRechnung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports